// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suk_cbnccF3qMz1Nwokx {
  position: relative;
  height: 4.5rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0.3125rem 1.25rem 0;
}

.encOhHz2N4ku8gzPYBES {
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.pZSMrn2X2afsRwXrDxs3 {
  top: 50%;
  right: unset;
  bottom: unset;
  left: 50%;
  width: 31.25rem;
  height: 16.25rem;
  border-radius: var(--panel-border-radius);
}

.aSkETwTdESp6hGKKQUjD {
  margin-top: auto;
  margin-bottom: 1rem;
}

.UPzYuhcDDbSlJbVB1_EN {
  margin-top: auto;
  text-align: center;
}

@media only screen and
  (max-width: 639px) {
  .encOhHz2N4ku8gzPYBES {
    height: 10.625rem;
  }

  .pZSMrn2X2afsRwXrDxs3 {
    position: absolute;
    top: unset;
    left: 0;
    bottom: 0;
    width: 100%;
    height: auto;
    padding: 0 1rem 1rem;
    border-radius: var(--panel-border-radius) var(--panel-border-radius) 0 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SuccessModal/SuccessModal.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,2BAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,SAAS;EACT,eAAY;EACZ,gBAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EACE;IACE,iBAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,SAAS;IACT,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,wEAAwE;EAC1E;AACF","sourcesContent":[".modalHeader {\n  position: relative;\n  height: 72px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin: 5px 20px 0;\n}\n\n.modalContent {\n  padding: 0 16px;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.modalContentWrapper {\n  top: 50%;\n  right: unset;\n  bottom: unset;\n  left: 50%;\n  width: 500px;\n  height: 260px;\n  border-radius: var(--panel-border-radius);\n}\n\n.button {\n  margin-top: auto;\n  margin-bottom: 16px;\n}\n\n.message {\n  margin-top: auto;\n  text-align: center;\n}\n\n@media (--mobile) {\n  .modalContent {\n    height: 170px;\n  }\n\n  .modalContentWrapper {\n    position: absolute;\n    top: unset;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: auto;\n    padding: 0 16px 16px;\n    border-radius: var(--panel-border-radius) var(--panel-border-radius) 0 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalHeader": `suk_cbnccF3qMz1Nwokx`,
	"modalContent": `encOhHz2N4ku8gzPYBES`,
	"modalContentWrapper": `pZSMrn2X2afsRwXrDxs3`,
	"button": `aSkETwTdESp6hGKKQUjD`,
	"message": `UPzYuhcDDbSlJbVB1_EN`
};
export default ___CSS_LOADER_EXPORT___;
